import { z } from "zod";

export const PortalFeatureKeySchema = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
export type PortalFeatureKey = z.infer<typeof PortalFeatureKeySchema>;

export const PortalFeaturesSchema = z.record(z.string().max(64), z.boolean());
export type PortalFeatures = z.infer<typeof PortalFeaturesSchema>;

export function isPortalFeatureEnabled(
  features: Partial<PortalFeatures> | null | undefined,
  key: PortalFeatureKey,
): boolean {
  return features?.[key] !== false;
}

export const PortalFeatureSettingsResponseSchema = z.object({
  features: PortalFeaturesSchema,
});
export type PortalFeatureSettingsResponse = z.infer<typeof PortalFeatureSettingsResponseSchema>;
